import React from 'react'
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import { Container } from "../../../components/Container"

import "./index.css"

const Confirmation = ({ data }) => (
    <div className='page-confirmation'>
        <Container>
            <div className='grid col-3-6 col-1-md align-center'>
                <div className='sp-image-wrap'>
                    <GatsbyImage
                        image={getImage(data.contentfulPage.pageMediaList[0])}
                        alt={`${data.contentfulPage.pageTitle} thumbnail`}
                    />
                </div>
                <div className='page-confirmation__content'>
                    {data.contentfulPage.pageLanguage !== null ? (
                        <div className='mb-0'>
                            <h1 className='text--dark'>¡Mensaje Enviado!</h1>
                            <p className="whitespace--prewrap bold">¡Gracias por contactar a Savor Brands!</p>
                            <p className="whitespace--prewrap bold">No dudes en llamarnos al <a href="tel:+18085998988">(808)-599-8988</a> o dejar tu información de contacto y un mensaje, y nos pondremos en contacto contigo pronto.</p>
                        </div>
                    ) : (
                        <div className='mb-0'>
                            <h1 className='text--dark'>Message Sent!</h1>
                            <p className="whitespace--prewrap bold">Thank you for contacting Savor Brands!</p>
                            <p className="whitespace--prewrap bold">Please feel free to call us <a href="tel:+18085998988">(808)-599-8988</a> or leave us your contact information and a message and we’ll be in touch soon.</p>
                        </div>
                    )}
                </div>
            </div>
        </Container>
    </div>
)

export default Confirmation